export default {
  cancel: 'Скасувати рахунок',
  saveAsTemplate: 'Зберегти як шаблон',
  messages: {
    stripeWarning: 'Оплата через платіжну систему Stripe доступна тільки на  '
  }
};
